<div *ngIf="transferType === 0">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'settings_subaccount_credit_assignment' | translate }}</h5>
    <button type="button" class="close" (click)="dismiss.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body d-flex flex-column">
    <div class="mb-3">
      <h6>{{ 'settings_subaccounts_movecredit_subaccount' | translate }}{{ ': ' + subaccount.login }}</h6>
    </div>
    <form [formGroup]="realCreditsForm">
      <div class="d-flex flex-row justify-content-between pb-5">
        <div class="customCard">
          <div class="mb-3">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'settings_subaccounts_credit_eat_mode_1' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let smsAvailability of smsAvailability?.superAccount">
                  <td>{{ 'credit_type_' + smsAvailability.messageType.toLowerCase() | translate }}</td>
                  <td style="text-align: right;">
                    <div class="border rounded-pill text-center">
                      <span class="mx-1">{{ smsAvailability.availability }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div style="align-self: center;" [ngStyle]="{ transform: !direction.checked ? 'rotateY(180deg)' : '' }">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </div>

        <div class="customCard">
          <div class="mb-3">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'settings_subaccounts_subcredit' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let smsAvailability of smsAvailability?.subAccount">
                  <td *ngIf="smsAvailability.idNation && smsAvailability.messageType.toLowerCase() === 'gp'">
                    {{ findLabelNation(smsAvailability.idNation) }}
                  </td>
                  <td *ngIf="!smsAvailability.idNation || smsAvailability.messageType.toLowerCase() !== 'gp'">
                    {{ 'credit_type_' + smsAvailability.messageType.toLowerCase() | translate }}
                  </td>
                  <td style="text-align: right;">
                    <div class="border rounded-pill text-center">
                      <span class="mx-1">{{ smsAvailability.availability }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row justify-content-between pb-5">
        <div style="width: 47%; margin-right: 6%; display: flex; align-items: baseline;">
          <input #direction style="margin-right: 5px;" formControlName="superTosub" type="radio" [value]="true" />
          <label for="subaccount" class="" translate>settings_subaccounts_movecredit_direction_tosub</label>
        </div>

        <div style="width: 47%; display: flex; align-items: baseline;">
          <input #direction style="margin-right: 5px;" formControlName="superTosub" type="radio" [value]="false" />
          <label for="subaccount" class="" translate>settings_subaccounts_movecredit_direction_tosuper</label>
        </div>
      </div>

      <div class="d-flex">
        <div class="col-sm-4 pe-4">
          <label translate>settings_subaccounts_movecredit_qty</label>
          <input type="text" formControlName="amount" class="form-control" />
        </div>

        <div class="col-sm-4">
          <label translate>common_message_type</label>
          <ng-container>
            <ng-select
              [items]="smsType"
              class="form-control"
              bindLabel="label"
              bindValue="value"
              formControlName="idMessageType"
              [clearable]="false"
            >
            </ng-select>
          </ng-container>
        </div>
      </div>
    </form>

    <div class="modal-footer">
      <div #modalFooter><ng-content select="[footer]"></ng-content></div>
      <div *ngIf="!modalFooter.innerHTML.trim()">
        <wsb-atlas-button
          variant="secondary"
          class="secondary me-3"
          data-dismiss="modal"
          (btnClick)="dismiss.emit()"
          label="common_cancel"
        ></wsb-atlas-button>
        <wsb-atlas-button [disabled]="realCreditsForm.invalid" variant="primary" (btnClick)="send()" label="common_ok"></wsb-atlas-button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="transferType === 2">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'settings_subaccount_credit_assignment' | translate }}</h5>
    <button type="button" class="close" (click)="dismiss.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body d-flex flex-column">
    <div class="mb-3">
      <span translate>settings_subaccount_assign_to_sub </span>
      <span style="font-weight: 600;">{{ subaccount.login }}</span>
      <!-- <h6>{{ 'settings_subaccounts_movecredit_subaccount' | translate }}{{ ': ' + subaccount.login }}</h6> -->
    </div>

    <div *ngIf="user?.preferences.language === 'eng'">
      <span translate>settings_subaccount_current </span>
      <span style="font-weight: 600;">{{ subaccount.login }}</span>
      <span translate>settings_subaccount_credit_balance</span>
    </div>

    <div *ngIf="user?.preferences.language !== 'eng'">
      <span translate>settings_subaccount_current </span>
      <span style="font-weight: 600;">{{ subaccount.login }}</span>
    </div>

    <ul>
      <li *ngFor="let smsAvailability of smsAvailability?.subAccount">
        <div class="d-flex">
          <div style="width: 150px;">
            <span *ngIf="smsAvailability.idNation && smsAvailability.messageType.toLowerCase() === 'gp'">{{
              findLabelNation(smsAvailability.idNation)
            }}</span>
            <span *ngIf="!smsAvailability.idNation || smsAvailability.messageType.toLowerCase() !== 'gp'">{{
              'credit_type_' + smsAvailability.messageType.toLowerCase() | translate
            }}</span>
          </div>
          <div>{{ smsAvailability.availability }}</div>
        </div>
      </li>
    </ul>

    <div *ngIf="selectedPricePlan" class="mb-3">
      <label translate>settings_subaccount_select_pricing</label>
      <ng-container>
        <ng-select
          [items]="pricePlan"
          class="form-control"
          [(ngModel)]="selectedPricePlan"
          (change)="onChange()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          (scrollToEnd)="onScrollToEnd()"
        >
        </ng-select>
      </ng-container>
    </div>
    <form [formGroup]="virtualCreditsForm">
      <div class="d-flex flex-row justify-content-between pb-5">
        <div class="customCard">
          <div class="mb-3">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 53%; padding: 20px;">{{ 'settings_subaccount_funds_to_assign' | translate }}</th>
                  <th style="width: 130px;">
                    <div style="position: relative;">
                      <div class="d-flex">
                        <span class="icon">{{ getCurrency() }}</span>
                        <input
                          type="text"
                          formControlName="price"
                          class="form-control"
                          wsbAppControlValidator
                          [fc]="virtualCreditsForm.get('price')"
                        />
                      </div>
                      <!-- <span>{{ getCurrency()}}</span> -->
                      <!-- <i *ngIf="isUkCurrency" class="icon bi bi-currency-pound"></i> -->
                      <!-- <i *ngIf="!isUkCurrency" class="icon bi bi-currency-euro"></i> -->
                      <wsb-validation-error-msg
                        [fc]="virtualCreditsForm.get('price')"
                        class="custom-price-validation"
                      ></wsb-validation-error-msg>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="price-per-message">
                      {{ 'settings_subaccount_price_per_message' | translate }}
                    </div>
                  </td>
                </tr>
                <tr [formGroup]="messageType" *ngFor="let messageType of pricePerMessage.controls; let i = index">
                  <td style="vertical-align:middle">
                    <mat-checkbox [checked]="messageType.get('add').value" formControlName="add" class="me-3 pt-1">
                      <span
                        *ngIf="
                          messageType.get('idDestinationNation').value && messageType.get('idMessageType').value.toLowerCase() === 'gp'
                        "
                        >{{ findLabelNation(messageType.get('idDestinationNation').value) }}
                      </span>
                      <span
                        *ngIf="
                          !messageType.get('idDestinationNation').value || messageType.get('idMessageType').value.toLowerCase() !== 'gp'
                        "
                        >{{ 'credit_type_' + messageType.get('idMessageType').value.toLowerCase() | translate }}</span
                      >
                    </mat-checkbox>
                  </td>
                  <td style="vertical-align:middle">
                    <div class="col-dm-4">
                      <div class="d-flex">
                        <span class="icon">{{ getCurrency() }}</span>
                        <input
                          type="number"
                          step="0.001"
                          formControlName="unitPrice"
                          class="form-control"
                          [readonly]="!messageType.get('add').value"
                          wsbAppControlValidator
                          [fc]="messageType.get('unitPrice')"
                        />
                      </div>
                      <wsb-validation-error-msg
                        [fc]="messageType.get('unitPrice')"
                        class="custom-unit-price-validation"
                      ></wsb-validation-error-msg>
                    </div>
                  </td>
                  <td style="vertical-align:middle">
                    <wsb-atlas-button
                      *ngIf="messageType.get('idDestinationNation').value && messageType.get('idDestinationNation').value !== user.nation"
                      [variant]="'danger'"
                      [icon]="faTrash"
                      (click)="removePricePerNation(i)"
                      >{{ 'common_delete' | translate }}</wsb-atlas-button
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="1">
                    <label>{{ 'search_nations' | translate }}</label>
                  </td>
                  <td colspan="2">
                    <ng-select
                      (change)="selectNation($event)"
                      [items]="nations"
                      bindLabel="label"
                      [searchable]="true"
                      bindValue="id"
                      [clearable]="false"
                      class="form-control"
                    >
                    </ng-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div style="align-self: center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </div> -->

        <!-- <div class="customCard">
          <div class="mb-3">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'settings_subaccounts_subcredit' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let smsAvailability of smsAvailability?.subAccount">
                  <td>{{ 'credit_type_' + smsAvailability.messageType.toLowerCase() | translate }}</td>
                  <td style="text-align: right;">
                    <div class="border rounded-pill text-center">
                      <span class="mx-1">{{ smsAvailability.availability }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
      </div>
    </form>
    <div class="modal-footer">
      <div #modalFooter><ng-content select="[footer]"></ng-content></div>
      <div *ngIf="!modalFooter.innerHTML.trim()">
        <wsb-atlas-button
          variant="secondary"
          class="secondary me-3"
          data-dismiss="modal"
          (btnClick)="dismiss.emit()"
          label="common_cancel"
        ></wsb-atlas-button>
        <wsb-atlas-button
          variant="primary"
          [disabled]="virtualCreditsForm.invalid"
          (btnClick)="send()"
          label="common_ok"
        ></wsb-atlas-button>
      </div>
    </div>
  </div>
</div>
